import { render, staticRenderFns } from "./exchangeTable.vue?vue&type=template&id=90dfb9ac&scoped=true&"
import script from "./exchangeTable.vue?vue&type=script&lang=js&"
export * from "./exchangeTable.vue?vue&type=script&lang=js&"
import style0 from "./exchangeTable.vue?vue&type=style&index=0&id=90dfb9ac&lang=stylus&scoped=true&"
import style1 from "./exchangeTable.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90dfb9ac",
  null
  
)

export default component.exports